__turbopack_context__.v({
  "searchSlider": "search-slider-module-scss-module__aOAo6G__searchSlider",
  "searchSlider_backToSearch": "search-slider-module-scss-module__aOAo6G__searchSlider_backToSearch",
  "searchSlider_container": "search-slider-module-scss-module__aOAo6G__searchSlider_container",
  "searchSlider_container__left": "search-slider-module-scss-module__aOAo6G__searchSlider_container__left",
  "searchSlider_content": "search-slider-module-scss-module__aOAo6G__searchSlider_content",
  "searchSlider_listingTypes": "search-slider-module-scss-module__aOAo6G__searchSlider_listingTypes",
  "searchSlider_search": "search-slider-module-scss-module__aOAo6G__searchSlider_search",
});
